import React from "react";
import { Container, Row, Col } from "reactstrap";

// Coordenadas de la entrada de la clínica. Única fuente: las usan tanto el
// mapa incrustado como el botón "Cómo llegar".
const COORDS = "-38.959752,-68.233110";
const NOMBRE = "Hana Clínica Integral";

export default function Location() {
  return (
    <div className="section" id="location" style={{ scrollMarginTop: 90 }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md="8" className="text-center">
            <h2 className="section-title reveal">
              <i
                className="tim-icons icon-square-pin"
                aria-hidden="true"
                style={{ fontSize: "0.7em", marginRight: 12, verticalAlign: "middle" }}
              />
              Ubicación
            </h2>
            <p className="location-meta reveal">
              Nos encontramos en <strong>Av. Plottier 346, Plottier (Neuquén)</strong>.
            </p>
            <p className="location-meta reveal">
              <strong>Horarios:</strong> Lunes a viernes de 9 a 18 hs
            </p>
            <a
              href={`https://www.google.com/maps/dir/?api=1&destination=${COORDS}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-sm mt-2 reveal"
            >
              Cómo llegar
            </a>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8" className="d-flex justify-content-center reveal">
            <div className="map-frame">
              <iframe
                title="Mapa de la clínica"
                src={`https://www.google.com/maps?q=${COORDS}(${encodeURIComponent(NOMBRE)})&z=18&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0, minWidth: 200, display: "block" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
